<template>
  <div v-if="model">
    <div class="position-relative">
      <input type="date" v-model="value" class="form-control form-control-solid" :placeholder="model.name"
             @keyup="emitUpdate" :disabled="isDisabled" @change="emitUpdate">
      <div class="input-check pe-10">
        <i class="fad fa-check-circle text-primary"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {helper} from "@/services/Helper";
import CONSTANTS from "@/Utils/constant";

@Component({})
export default class PropertyDate extends Vue {
  @Prop() itemUuid!: string
  @Prop() propertyCode!: string
  @Prop({default: false}) isDisabled!: boolean

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.itemUuid)
  }

  get model() {
    if (!this.item) return null
    const itemType = this.$store.state.contractStore.itemTypes[this.item.modelCode]
    if (!itemType?.properties) return null
    return (Object.values(itemType.properties) as any[]).find((pm: any) => pm.code === this.propertyCode) || null
  }

  get value() {
    return this.item?.properties?.[this.propertyCode]
  }

  set value(v: any) {
    if (this.item) {
      Vue.set(this.item.properties, this.propertyCode, v)
    }
  }

  mounted() {
    this.setCustom()
    this.checkMin()
    this.checkMax()
  }

  checkMin() {
    if (this.model?.min !== null && this.model?.min !== undefined && !isNaN(this.model.min)) {
      const min = helper.dateFromCode(this.model.min)
      const current = this.value ? new Date(this.value) : null
      if (!current || current.getTime() < min.getTime()) {
        this.value = helper.reversedDateToHtml(min)
      }
    }
  }

  checkMax() {
    if (this.model?.max !== null && this.model?.max !== undefined && !isNaN(this.model.max)) {
      const max = helper.dateFromCode(this.model.max)
      const current = this.value ? new Date(this.value) : null
      if (current && current.getTime() > max.getTime()) {
        this.value = helper.reversedDateToHtml(max)
      }
    }
  }

  setCustom() {
    if (this.model?.value && CONSTANTS.dateConstants.hasOwnProperty(this.model.value)) {
      const date = (CONSTANTS.dateConstants as any)[this.model.value as any]()
      this.value = date.toISOString().substring(0, 10)
    }
  }

  emitUpdate() {
    this.$emit('propertyUpdated', {code: this.propertyCode, itemUuid: this.itemUuid})
  }
}
</script>

<style scoped>
</style>
